import { flagsEqual, mergeFlags, normalizeFlags, type OnboardingFlags } from './flags';

/** Profile field holding onboarding flags. */
export const UI_FLAGS_FIELD = 'ui_flags';

/** The server's snake_case shape for `ui_flags`. */
export const serializeFlags = (flags: OnboardingFlags) => ({
  seen_tours: flags.seenTours,
  dismissed_hints: flags.dismissedHints,
  checklist_dismissed: flags.checklistDismissed,
  checklist_collapsed: flags.checklistCollapsed,
  updated_at: flags.updatedAt,
});

/**
 * Whether the signed-in user's profile carries `ui_flags`. Until the backend
 * adds the field, sync stays off rather than sending a field it would reject.
 */
export const serverSupportsFlags = (user: Record<string, unknown> | null | undefined): boolean =>
  !!user && Object.prototype.hasOwnProperty.call(user, UI_FLAGS_FIELD);

/**
 * On sign-in: combine this browser's flags with the server's (anything seen on
 * either side stays seen) and say whether the server needs the result.
 */
export function planLoginMerge(local: OnboardingFlags, serverRaw: unknown) {
  const server = normalizeFlags(serverRaw);
  const merged = mergeFlags(local, server);
  return { merged, push: !flagsEqual(merged, server) };
}
